function t(translations, jsonPath, ignoreMissing = false) {
  let parts = jsonPath.split('.')
  let result = translations
  for (let i = 0; i < parts.length; i++) {
    let segment = parts[i]
    if (result[segment] === undefined) {
      if (ignoreMissing) {
        result = false
      } else {
        result = '? ' + jsonPath
      }
      break
    } else {
      result = result[segment]
    }
  }
  //return '√' + result
  return result
}

export {
  t
}
